<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Labs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Labs",
            items: [
               {
                  text: "Labs",
                  active: true,
               },                   
            ],

            labs: [],
            lab_status: {
               id: "",
               status: "",
            },
            limit: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            pagination: {},
            from: "",
            to: "",
            total: "",

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchLabs();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         
         fetchLabs(page_url = null){

            this.getToken();

            let url = "api/admin/lab/index?limit=" + this.limit + "&status=" + this.status + "&search=" + this.keyword;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var data = res.data.data;
                  console.log(data);

                  this.labs = data.data;
                  this.from = data.from;
                  this.to = data.to;
                  this.total = data.total;
                  this.pagination = data.links;

               })
               .catch((error) => {

                  if (error.response) {
                     if (error.response.data.message) {

                        if (typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     }
                     else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }

               })
               .finally(() => (this.loading = false));


         },


         labUnpublish(lab){

         this.getToken();

         const config = {
            headers: {

               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
         };

         let url = "api/admin/lab/unpublish";
         let formData = new FormData();
         formData.append("id", lab.id);
         formData.append("status", '2');

         this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchLabs();
               this.$router.push({ name: 'labs' });
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
            this.fetchBooking();
         },

         labPublish(lab){

         this.getToken();

         const config = {
            headers: {

               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
         };

         let url = "api/admin/lab/publish";
         let formData = new FormData();
         formData.append("id", lab.id);
         formData.append("status", '2');

         this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchLabs();
               this.$router.push({ name: 'labs' });
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
            this.fetchBooking();
         },
         labDelete(lab) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to delete this lab account?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                     this.getToken();

                     const config = {
                        headers: {

                           "Accept": "application/json",
                           "Authorization": "Bearer " + this.token,
                        },
                     };

                     let url = "api/admin/lab/delete";
                     let formData = new FormData();
                     formData.append("lab_id", lab.id);

                     this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                           if (response.data.status) {
                              this.$swal("", response.data.message, "success");
                           } else {
                              this.$swal("", response.data.message, "error");
                           }
                           this.fetchLabs();
                           this.$router.push({ name: 'labs' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 


         formatDate(dateString) {
			const date = new Date(dateString);

			const day = date.getDate();
			const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
			const year = date.getFullYear();

			const hours24 = date.getHours();
			const minutes = date.getMinutes();
			const hours12 = hours24 % 12 || 12;
			const ampm = hours24 >= 12 ? 'PM' : 'AM';

			return `${day} ${month} ${year}, ${hours12}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
		},

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">                        
                        <router-link :to="{ name: 'labs.add' }" class="btn btn-primary float-end">Add Lab</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="limit" @change="fetchLabs()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchLabs()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchLabs()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="20%">Name</th>  
                              <th width="15%">Place</th> 
                              <th width="15%">Phone</th> 
                              <th width="20%">Created On</th>
                              <th width="30%">Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(labs.length)">
                           <tr v-for="(lab) in labs" :key="lab.id">
                              <td>{{ lab.lab_name }}</td>
                              <td>{{ lab.address }}</td>
                              <td>{{ lab.mobile }}</td>
                              <td>{{ formatDate(lab.created_at) }}</td>
                              <td>
                                 <router-link :to="{ name: 'labs.details' , params: { id: lab.id }}"
                                 class="btn btn-primary btn-sm me-2 mb-2">Profile</router-link>
                                 <router-link :to="{ name: 'labs.edit', params: { id: lab.id }}" 
                                 class="btn btn-primary btn-sm me-2 mb-2">Edit</router-link>
                                 <router-link :to="{ name: 'labs.bookings', params: { id: lab.id, type: lab.token_management_type}}"
                                  class="btn btn-primary btn-sm me-2 mb-2">Bookings</router-link>
                                 <template v-if="lab.token_management_type == 1">
                                    <router-link :to="{ name: 'labs.schedules', params: { id: lab.id }}"
                                    class="btn btn-primary btn-sm me-2 mb-2">Schedules</router-link>
                                    <router-link :to="{ name: 'labs.tests', params: { id: lab.id }}"
                                    class="btn btn-primary btn-sm me-2 mb-2">Tests</router-link>
                                 </template>
                                 <template v-else>
                                    <router-link :to="{ name: 'labs.counters', params: { id: lab.id }}"
                                    class="btn btn-primary btn-sm me-2 mb-2">Counters</router-link>
                                    <router-link :to="{ name: 'labs.tokenCalls', params: { id: lab.id }}"
                                    class="btn btn-primary btn-sm me-2 mb-2">Outsource Token Calls</router-link>
                                    <router-link :to="{ name: 'module.tvs', params: { id: lab.id, module: 'lab' }}"
                                    class="btn btn-primary btn-sm me-2 mb-2">Tvs</router-link>
                                 </template>
                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                 v-if="lab.status == 1" @click="labUnpublish(lab)" >Unpublish</b-button>
                                 <b-button variant="success" class="btn-sm me-2 mb-2"
                                 v-if="lab.status == 2" @click="labPublish(lab)" >Publish</b-button>

                                 <b-button variant="danger" class="btn-sm me-2 mb-2"
                                  @click="labDelete(lab)" >Delete</b-button>
                              </td>
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No labs found</td>
                           </tr>
                        </tbody>

                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->   
                  <caption v-if="Boolean(labs.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchLabs(page.url + '&limit='+ limit + '&status=' + status + '&search=' + keyword)">
                        <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                        <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                        <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

              

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
